export const SET_TEACH_ASSISTANT_INFO = 'SET_TEACH_ASSISTANT_INFO' // 存储学员列表筛选信息
export const SET_COURSE_CONTENT = 'SET_COURSE_CONTENT' // 存储课程图文详情
export const SET_TEACH_ASSISTANT_STORE_INFO = 'SET_TEACH_ASSISTANT_STORE_INFO' // 存储助教选择门店
export const SET_CLASS_LIST_REQUEST = 'SET_CLASS_LIST_REQUEST' // 存储课程管理请求参数
